export const applyPostImpressionismStyle = async (canvas, ctx, setMessage, language) => {
  // 후기 인상주의: 강한 윤곽선과 감정적 색채
  const imageData = ctx.getImageData(0, 0, canvas.width, canvas.height);
  const data = imageData.data;
  
  // 1. 감정적 색채 강화
  for (let i = 0; i < data.length; i += 4) {
    // 색상 강화 및 대비 증가
    const r = data[i];
    const g = data[i + 1];
    const b = data[i + 2];
    
    // Van Gogh 스타일의 색상 변환
    if (r > g && r > b) {
      // 빨간색 계열 강화
      data[i] = Math.min(255, r * 1.2);
      data[i + 1] = Math.min(255, g * 0.9);
      data[i + 2] = Math.min(255, b * 0.8);
    } else if (g > r && g > b) {
      // 녹색 계열 강화
      data[i] = Math.min(255, r * 0.9);
      data[i + 1] = Math.min(255, g * 1.2);
      data[i + 2] = Math.min(255, b * 0.8);
    } else if (b > r && b > g) {
      // 파란색 계열 강화
      data[i] = Math.min(255, r * 0.8);
      data[i + 1] = Math.min(255, g * 0.9);
      data[i + 2] = Math.min(255, b * 1.2);
    }
  }
  
  ctx.putImageData(imageData, 0, 0);
  
  // 2. 강한 윤곽선 추가
  const tempCanvas = document.createElement('canvas');
  tempCanvas.width = canvas.width;
  tempCanvas.height = canvas.height;
  const tempCtx = tempCanvas.getContext('2d');
  tempCtx.drawImage(canvas, 0, 0);
  
  const edgeData = ctx.getImageData(0, 0, canvas.width, canvas.height);
  const edgePixels = edgeData.data;
  const tempData = tempCtx.getImageData(0, 0, canvas.width, canvas.height).data;
  
  // 소벨 엣지 검출로 윤곽선 강화
  for (let y = 1; y < canvas.height - 1; y++) {
    for (let x = 1; x < canvas.width - 1; x++) {
      const pos = (y * canvas.width + x) * 4;
      
      for (let c = 0; c < 3; c++) {
        const gx = 
          -1 * tempData[((y - 1) * canvas.width + (x - 1)) * 4 + c] +
           1 * tempData[((y - 1) * canvas.width + (x + 1)) * 4 + c] +
          -2 * tempData[(y * canvas.width + (x - 1)) * 4 + c] +
           2 * tempData[(y * canvas.width + (x + 1)) * 4 + c] +
          -1 * tempData[((y + 1) * canvas.width + (x - 1)) * 4 + c] +
           1 * tempData[((y + 1) * canvas.width + (x + 1)) * 4 + c];
        
        const gy = 
          -1 * tempData[((y - 1) * canvas.width + (x - 1)) * 4 + c] +
          -2 * tempData[((y - 1) * canvas.width + x) * 4 + c] +
          -1 * tempData[((y - 1) * canvas.width + (x + 1)) * 4 + c] +
           1 * tempData[((y + 1) * canvas.width + (x - 1)) * 4 + c] +
           2 * tempData[((y + 1) * canvas.width + x) * 4 + c] +
           1 * tempData[((y + 1) * canvas.width + (x + 1)) * 4 + c];
        
        const magnitude = Math.sqrt(gx * gx + gy * gy);
        
        if (magnitude > 20) {
          // 윤곽선 부분을 더 어둡게
          edgePixels[pos + c] = Math.max(0, tempData[pos + c] - magnitude * 0.5);
        } else {
          edgePixels[pos + c] = tempData[pos + c];
        }
      }
    }
  }
  
  ctx.putImageData(edgeData, 0, 0);
  
  // 3. 붓터치 패턴 (후기 인상주의의 특징적인 붓질)
  const strokeData = ctx.getImageData(0, 0, canvas.width, canvas.height);
  const strokePixels = strokeData.data;
  
  for (let y = 0; y < canvas.height; y += 6) {
    for (let x = 0; x < canvas.width; x += 6) {
      // 지역적 색상 변화 추가
      const variation = (Math.random() - 0.5) * 30;
      
      for (let dy = 0; dy < 6 && y + dy < canvas.height; dy++) {
        for (let dx = 0; dx < 6 && x + dx < canvas.width; dx++) {
          const pos = ((y + dy) * canvas.width + (x + dx)) * 4;
          
          for (let c = 0; c < 3; c++) {
            strokePixels[pos + c] = Math.min(255, Math.max(0, strokePixels[pos + c] + variation));
          }
        }
      }
    }
  }
  
  ctx.putImageData(strokeData, 0, 0);
};